import React, { useEffect, useState, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { DetailedFormContainer } from "pages/contractorDashboard/styles.js";
import { LargeText, SetupContainer } from "../styles.js";
import { ActiveAgentList } from "./ActiveAgentList.js";
import { DetailArea } from "pages/contractorDashboard/detailScreens/styles.js";
import { SearchBar } from "pages/contractorDashboard/detailScreens/SearchBar";
import { getAdminUsers } from "../../../api/external_data.js";
import { disableSingleClientIDPeSUB, enableSingleClientIDPeSUB } from "../../../api/onboarding_client.js";

export default function ActiveIDPeSUB({ noWidthChange }) {
  const [query, setQuery] = useState("");
  const isMobile = useMediaQuery({ maxWidth: 480 });
  const [filteredData, setFilteredData] = useState([]);
  const [internalSearchResults, setInternalSearchResults] = useState(filteredData);
  const [openPopup, setOpenPopup] = useState(false);
  const [client, setClient] = useState("");
  const [initialSubCategory, setInitialSubCategory] = useState("");
  let subCategoryInfo = [];
  const hasFetched = useRef(false);

  const handleFilter = async () => {
    try {
      const res = await getAdminUsers(); // assume this hits the /admin/users API
      setFilteredData(res);
    } catch (error) {
      console.error("Failed to fetch admin users:", error);
    }
  };


  useEffect(() => {
    if (!hasFetched.current) {
      handleFilter();
      hasFetched.current = true;
    }
  }, []);



  //three dots button

  const deActiveIDPeSUB = (id) => {
    disableSingleClientIDPeSUB(id, onSuccessDeActiveIDPeSUB, () => { });
  };

  const onSuccessDeActiveIDPeSUB = (res) => {
    // setQuery("");
    handleFilter("");
  };


  const activeIDPeSUB = (id) => {
    enableSingleClientIDPeSUB(id, onSuccessActiveIDPeSUB, () => { });
  };
  const onSuccessActiveIDPeSUB = (res) => {
    // setQuery("");
    handleFilter("");
  };

  return (
    <SetupContainer isMobile={isMobile}>
      <DetailedFormContainer isMobile={isMobile} noWidthChange={noWidthChange}>
        <LargeText isMobile={isMobile}>
          {isMobile
            ? "All Client"
            : "All Client's List"}
        </LargeText>

        <SearchBar
          filteredData={filteredData}
          setInternalSearchResults={setInternalSearchResults}
          query={query}
          setQuery={setQuery}
          searchWidth="100%"
          internalSearch={true}
        />

        <DetailArea>
          <ActiveAgentList
            filteredData={
              query && query !== "" ? internalSearchResults : filteredData
            }
            deActiveIdpEsub={deActiveIDPeSUB}
            activeIdpEsub={activeIDPeSUB}
            isMobile={isMobile}
          />
        </DetailArea>


      </DetailedFormContainer>
    </SetupContainer>
  );
}

